












































import { Component, Prop, Vue } from 'vue-property-decorator'
import { CmsApiUtil } from "@/_common/api/utils/cms_api_utils";

@Component({})
export default class DatePeriodSelector extends Vue {

    @Prop() private _periodStart!: Date;
    @Prop() private _periodEnd!: Date;
    @Prop() private isFocusedByError!: boolean;

    get periodStart(): Date {
        return this._periodStart
    }

    set periodStart(value: Date) {
        this.$emit('change', value, this._periodEnd)
    }

    get periodEnd(): Date {
        return this._periodEnd
    }

    set periodEnd(value: Date) {
        this.$emit('change', this._periodStart, value)
    }

    private focusPeriodStart() {
        if (isNaN(this._periodStart.getTime())) {
            this.$emit('change', CmsApiUtil.dateToUI(CmsApiUtil.dateToDB(new Date())), this._periodEnd);
        }
    }

    private focusPeriodEnd() {
        if (isNaN(this._periodEnd.getTime())) {
            this.$emit('change', this._periodStart, CmsApiUtil.dateToUI(CmsApiUtil.dateToDB(new Date())));
        }
    }
}
